import { getSearchParams } from '@wix/package-picker-shared';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { useEffect } from 'react';
import { useCurrentModule } from '../components';
import { resolveRecommendation } from './resolveRecommendation';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
export const useEclipsePlanRecommendation = () => {
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    isEnabled
  } = useAiRecommendationEnabled();
  const {
    siteGuid
  } = getSearchParams();
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const {
    data: rawData,
    isLoading,
    isError
  } = module.SDK.planRecommendationApiClient.hooks.useGetPlanRecommendation({
    siteGuid,
    p3Context
  }, isEnabled, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    useErrorBoundary: false
  });
  const recommendedProductName = (rawData == null ? void 0 : rawData.recommendedProductName) ?? '';
  const resolved = resolveRecommendation({
    data: rawData,
    recommendedProductName,
    t
  });
  const resolvedProductId = resolved == null ? void 0 : resolved.recommendedProductId;
  useEffect(() => {
    if (isEnabled && resolvedProductId) {
      module.SDK.aiRecommendationStore.setRecommendedProductId(resolvedProductId);
    }
  }, [isEnabled, resolvedProductId, module]);
  return {
    data: resolved,
    isLoading: isEnabled && isLoading,
    isError: isEnabled && isError,
    isEnabled,
    recommendedProductName
  };
};
//# sourceMappingURL=useEclipsePlanRecommendation.js.map